webpackJsonp([131463666383785],{

/***/ 121:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.ministriesPageQuery = exports.MinistriesPageTemplate = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactHelmet = __webpack_require__(30);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _Page = __webpack_require__(31);
	
	var _Page2 = _interopRequireDefault(_Page);
	
	var _SideNav = __webpack_require__(64);
	
	var _SideNav2 = _interopRequireDefault(_SideNav);
	
	var _ministriesModule = __webpack_require__(185);
	
	var _ministriesModule2 = _interopRequireDefault(_ministriesModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MinistriesPageTemplate = exports.MinistriesPageTemplate = function MinistriesPageTemplate(_ref) {
	  var pages = _ref.pages,
	      title = _ref.title,
	      content = _ref.content;
	  return _react2.default.createElement(
	    _Page2.default,
	    { className: _ministriesModule2.default.component, title: 'Ministries' },
	    _react2.default.createElement(_reactHelmet2.default, { title: title + ' | Ministries' }),
	    _react2.default.createElement(_SideNav2.default, { pages: pages }),
	    _react2.default.createElement(
	      'article',
	      { className: _ministriesModule2.default.article },
	      _react2.default.createElement(
	        'h2',
	        { className: _ministriesModule2.default.articleTitle },
	        title
	      ),
	      _react2.default.createElement('div', {
	        className: _ministriesModule2.default.articleContent,
	        dangerouslySetInnerHTML: { __html: content }
	      })
	    )
	  );
	};
	
	MinistriesPageTemplate.defaultProps = {
	  pages: [],
	  title: ''
	};
	
	MinistriesPageTemplate.propTypes = {
	  pages: _propTypes2.default.array,
	  title: _propTypes2.default.string,
	  content: _propTypes2.default.node.isRequired
	};
	
	var MinistriesPage = function MinistriesPage(_ref2) {
	  var data = _ref2.data;
	  var pages = data.allMarkdownRemark.edges;
	  var page = data.markdownRemark;
	  var title = page.frontmatter.title,
	      html = page.html;
	
	
	  return _react2.default.createElement(MinistriesPageTemplate, { pages: pages, title: title, content: html });
	};
	
	MinistriesPage.propTypes = {
	  data: _propTypes2.default.shape({
	    allMarkdownRemark: _propTypes2.default.shape({
	      edges: _propTypes2.default.array
	    }),
	    markdownRemark: _propTypes2.default.object
	  }).isRequired
	};
	
	exports.default = MinistriesPage;
	var ministriesPageQuery = exports.ministriesPageQuery = '** extracted graphql fragment **';

/***/ }),

/***/ 185:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"article":"src-templates----ministries-module---article---1B-rs","articleTitle":"src-templates----ministries-module---articleTitle---3CH1c","articleContent":"src-templates----ministries-module---articleContent---eFT1C","component":"src-templates----ministries-module---component---20QwG"};

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-ministries-js-dc1dd15c9e4fcf7e5f09.js